<div>
  <div class="d-flex">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'page.widgetContent.addEditDialog.imageLink' | translate }}</mat-label>
      <input matInput [formControl]="urlControl" />
      <mat-error [control]="urlControl"></mat-error>
    </mat-form-field>
    <button
      type="button"
      class="d-flex"
      mat-icon-button
      (click)="addUrl()"
      [disabled]="!urlControl.value?.toString().trim()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="upload-thumbnails-row">
    <button
      type="button"
      mat-stroked-button
      class="upload-button"
      aria-label="Upload Image"
      (click)="fileInput.click()"
    >
      <mat-icon>upload</mat-icon>
      <span>{{ 'button.uploadFile' | translate }}</span>
    </button>
    <input
      type="file"
      #fileInput
      accept="image/png,image/jpeg,image/jpg"
      multiple
      hidden
      (change)="onFileSelected($event)"
    />

    <div class="thumbnails">
      <div class="thumb" *ngFor="let thumbnail of thumbnails; let i = index">
        <div class="thumb-img-wrap">
          <img [src]="thumbnail.filePath" (error)="onImageError()" />
          <div class="thumb-overlay">
            <button type="button" mat-icon-button class="thumb-eye" (click)="openImageDialog(thumbnail)">
              <mat-icon>visibility</mat-icon>
            </button>
            <button type="button" mat-icon-button class="thumb-delete" (click)="onClickedImageRemove(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
